import { useTranslation } from 'react-i18next';
import * as React from 'react';
import Filter from '../../../../core/components/Filter.tsx';
import { IFilter } from '../../../../core/utils/filterQuery.ts';

const STATUS_VALUES = ['COMPLETED', 'COMPLETED_NO_DATA', 'FAILED', 'PENDING', 'UNKNOWN'];

interface AgentStatusFilterProps {
    filters: IFilter[];
    onFiltersChange: (filters: IFilter[]) => void;
}

const AgentStatusFilter = ({ filters, onFiltersChange }: AgentStatusFilterProps) => {
    const { t } = useTranslation('agents');

    const filter = filters.find((f) => f.name === 'status');
    const selected = filter ? (Array.isArray(filter.value) ? filter.value : [filter.value]) : [];

    const options = STATUS_VALUES.map((value) => ({
        value,
        label: t(`historyPage.status.${value === 'COMPLETED_NO_DATA' ? 'completedNoData' : value.toLowerCase()}`),
    }));

    const handleSelectedChange = (newSelected: string[]) => {
        const newFilters = filters.filter((f) => f.name !== 'status');
        if (newSelected.length) {
            newFilters.push({ name: 'status', value: newSelected, exclude: false, expression: 'eq' });
        }
        onFiltersChange(newFilters);
    };

    return (
        <Filter
            allLabel={t('historyPage.filters.status.all')}
            label={t('historyPage.filters.status.label')}
            options={options}
            selected={selected}
            onSelectedChange={handleSelectedChange}
            multiple
            showMultipleCount
        />
    );
};

export default AgentStatusFilter;
